import { Directive } from '@angular/core';

@Directive({
  selector: '[rvSortableItem]',
  standalone: false,
  host: {
    class: 'rv-sortable-item',
    tabindex: '-1',
  },
})
export class RvSortableItemDirective {}
